import type { ChangeRequest } from '@src/changeRequest/domain/ChangeRequest';

export class ChangeRequestList {
  public readonly changeRequests: ChangeRequest[];

  constructor({ changeRequests }: { changeRequests: ChangeRequest[] }) {
    this.changeRequests = changeRequests;
  }

  getLastChangeDateFor(field: string, permitApplicationId?: string) {
    let lastUpdated: Date | undefined;
    for (const request of this.changeRequests) {
      const isAffected = permitApplicationId
        ? request.isAffectedForPermit(field, permitApplicationId)
        : request.isAffected(field);

      if (
        isAffected &&
        (!lastUpdated || request.requestedAt.getTime() > lastUpdated.getTime())
      ) {
        lastUpdated = request.requestedAt;
      }
    }

    return lastUpdated;
  }

  getLatestChangeRequest(): ChangeRequest | undefined {
    if (!this.changeRequests?.length) {
      return undefined;
    }
    let latest: ChangeRequest | undefined;
    for (const changeRequest of this.changeRequests) {
      if (
        !latest ||
        changeRequest.requestedAt.getTime() > latest.requestedAt.getTime()
      ) {
        latest = changeRequest;
      }
    }
    return latest;
  }

  add(changeRequest: ChangeRequest) {
    this.changeRequests.push(changeRequest);
  }
}
